import {Component, inject} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-overview-finished',
  imports: [
    ColoredBackgroundComponent,
    FooterComponent,
    RouterLink,
    FinishBoxComponent,
  ],
  templateUrl: './overview-finished.component.html',
  styleUrl: './overview-finished.component.css'
})
export class OverviewFinishedComponent {
  locale = inject(LocaleService);
}
